<div
  class="header pb-7 pt-5 pt-lg-7 d-flex align-items-center"
  style="
    min-height: 120px;
    background-size: cover;
    background-position: center top;
  "
>
  <span class="mask bg-gradient-primary opacity-8"></span>
  <div class="container-fluid d-flex align-items-center">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <h1 class="text-white">Categorias</h1>
        <p class="text-white mt-0 mb-5">Listagem de categorias</p>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid mt--7">
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <div class="card shadow">
        <div class="card-header border-0">
          <div class="row align-items-center">
            <div class="col-12 col-sm-auto">
              <a (click)="openModal()" class="btn btn-md btn-primary btn-block btn-sm-inline"
                ><i class="ni ni-fat-add"></i> Novo Cadastro</a
              >
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th scope="col">Descrição</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of items$ | async">
                <th scope="row">
                  {{ item?.description }}
                </th>
                <td class="text-right text-md-left">
                  <div class="category-actions">
                    <a
                      (click)="editar(item?.id)"
                      class="btn btn-sm btn-secondary"
                      ><i class="ni ni-ruler-pencil"></i>
                      <span class="d-none d-sm-inline"> Editar</span></a
                    >
                    <a (click)="delete(item?.id)" class="btn btn-sm"
                      ><i class="ni ni-fat-remove"></i>
                      <span class="d-none d-sm-inline"> Desativar</span></a
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-buttons"></div>
        <div class="card-footer py-4">
          <nav aria-label="...">
            <ul class="pagination justify-content-end mb-0">
              <li class="page-item">
                <button
                  class="page-link"
                  (click)="prevPage()"
                  [disabled]="!categoryService.hasPreviousPage"
                >
                  <i class="fas fa-angle-left"></i>
                  <span class="sr-only">Previous</span>
                </button>
              </li>
              <li class="page-item">
                <button
                  class="page-link"
                  [disabled]="!categoryService.hasNextPage"
                  (click)="nextPage()"
                >
                  <i class="fas fa-angle-right"></i>
                  <span class="sr-only">Next</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
